import React from 'react'
import classNames from 'classnames'
import { Dropdown } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {object[]} props.options
 * @param {string=} props.className
 * @param {import('react').CSSProperties=} props.style
 */
export default function OptionsDropdown({ options = [], className, style }) {
  return (
    <Dropdown
      icon="far fa-ellipsis-vertical"
      floating
      pointing="top right"
      basic
      button
      className={classNames('icon ph2 last:mr-0', className)}
      style={style}
    >
      <Dropdown.Menu>
        {options.map((option, index) => {
          return <Dropdown.Item {...option} key={index} onClick={option.onClick} />
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/OptionsDropdown/index.js